module.exports = __webpack_public_path__ + "img/3min_exam.62c8a532.png";